// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__33daF","sendOtp":"AuthorizeToLogin_sendOtp__2apPQ"};